module.exports = __webpack_public_path__ + "img/print.8313c300.svg";